import { useState } from "react";
import { communityRules, faqs } from "@/mocks/home";

export default function RulesAndFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      <section id="rules" className="w-full scroll-mt-24 bg-background-100/60 py-14 md:py-20" aria-labelledby="rules-title">
        <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
          <div className="max-w-2xl">
            <span className="flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-primary-700">
              <i className="ri-shield-check-line text-sm" aria-hidden="true" />
              COMMUNITY RULES · 吃瓜守则
            </span>
            <h2 id="rules-title" className="mt-3 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              热闹可以，越界不行
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              瓜田能一直开下去，靠的是大家守规矩。以下四条是底线，也是我们折叠评论和限制发言的唯一依据。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {communityRules.map((rule) => (
              <article key={rule.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                  <i className={`${rule.icon} text-2xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{rule.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{rule.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="faq" className="w-full scroll-mt-24 bg-background-50 py-14 md:py-20" aria-labelledby="faq-title">
        <div className="mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          <div>
            <span className="flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-accent-700">
              <i className="ri-question-line text-sm" aria-hidden="true" />
              FAQ · 常见问题
            </span>
            <h2 id="faq-title" className="mt-3 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              吃瓜之前，先看这几条
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于内容来源、投票机制和社区规范，你可能想知道的都在这里。还有疑问可以直接写信给编辑部。
            </p>
            <a
              href="mailto:editor@guatian-community.example"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-3 text-sm font-bold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-mail-send-line text-base" aria-hidden="true" />
              editor@guatian-community.example
            </a>
          </div>

          <div className="divide-y divide-background-200 border-y border-background-200">
            {faqs.map((faq, index) => {
              const open = openIndex === index;
              return (
                <div key={faq.q}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? null : index)}
                      aria-expanded={open}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
                    >
                      <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">{faq.q}</span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i className={open ? "ri-subtract-line text-lg" : "ri-add-line text-lg"} aria-hidden="true" />
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}